export default __webpack_public_path__ + "static/media/control-right-light-1.f66a2eb2.svg";